<template>
    <div class="freetargetImage-box">
        <div class="marqueeWrapper">
            <div class="raceGame-noteStrip">
              Notice : 🎉 Special Event Alert! 🎉 Starts on 20 Oct 2025 — Play More, Earn More! 🎁
            </div>
        </div>
        <img :src='DiwaliWeeklyTarget' alt="" /> 
    </div>    
</template>
<script>
import DiwaliWeeklyTarget from '../../assets/images/diwaliWeeklyTarget.webp'
export default {
    name: 'WeeklyTargetRule',
    data() {
        return {
            DiwaliWeeklyTarget: DiwaliWeeklyTarget,
        }
    },
}
</script>
